/* eslint-disable import/order */
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { forgeProjectModuleResource } from '@jira/navigation-apps__resources/src/controllers/forge/index.tsx';
import { staticProjectSidebarConnectAddonsNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar-connect-addons/index.tsx';
import { staticProjectSidebarNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { projectContextResource } from '@jira/router-resources__project-context/src/projectContextResource.tsx';
import { incidentExperimentTraitResource } from '@jira/router-resources__software-incidents/src/incidentExperimentTraitResource.tsx';
import { cmpCreatedVsResolvedBoardlessRoute } from '@jira/router-routes__classic-projects-routes/src/cmpCreatedVsResolvedBoardlessRoute.tsx';
import { createdVsResolvedReportPageEntrypoint } from '@jira/router-routes__next-gen-entries/src/ui/software/reports/created-vs-resolved/createdVsResolvedReportPageEntrypoint.tsx';
import { softwareProjectLayoutNoOnboarding } from '@jira/platform__layouts-software-project-layout/src/index.tsx';
import { getTMPReportsCommonResource } from './common/ui/resources/reports/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

export const cmpCreatedVsResolvedBoardlessRouteEntry: Route = createEntry(
	cmpCreatedVsResolvedBoardlessRoute,
	() => ({
		group: 'software',
		ufoName: 'software-reports.created-vs-resolved',

		entryPoint: () => createdVsResolvedReportPageEntrypoint,
		layout: softwareProjectLayoutNoOnboarding,

		navigation: {
			menuId: MenuIdProjects,
		},

		resources: [
			...getNavigationResources(),
			incidentExperimentTraitResource,
			projectContextResource,
			forgeProjectModuleResource,
			staticProjectSidebarNavigationResource,
			staticProjectSidebarConnectAddonsNavigationResource,
			...getTMPReportsCommonResource(),
		],

		supportsPreviewPanel: true,

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
